export default __webpack_public_path__ + "static/media/tom.72955fd8.png";